import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-modal.component.html'
})
export class ErrorModalComponent {
  notificationService = inject(NotificationService);

  close() {
    this.notificationService.clearErrorModal();
  }

  formatFieldName(field: string): string {
    if (!field) return '';
    if (field.toLowerCase() === 'cpf') return 'CPF';
    if (field.toLowerCase() === 'cnpj') return 'CNPJ';
    if (field.toLowerCase() === 'name') return 'Nome';
    if (field.toLowerCase().includes('contacts')) return 'Contato';
    return field;
  }
}
